import { Injectable } from '@angular/core';
import { IPlacemark } from '../../../../Store/placemarks.state/placemarks.model';
import { ILayer, STATUS_LAYER_MASK, LAYER_CREATED_BY_APP, STATUS_VISUALIZATION_METHOD } from '../../../../Store/layers.state/layers.model';
import { environment } from '../../../../../environments/environment';
import { STATUS_LAYER_ICON_PRE } from 'src/app/Store/layers.state/layers.const.utils';
import { StatusPlacemarkIconService } from 'src/app/services/status-placemark-icon.service';
import { StatusShape } from 'src/app/common/UI-Components/layer-status-design-picker/layer-status-design-picker.component';

@Injectable()
export class ContainersHelper {
  constructor(private readonly statusPlacemarkIconService: StatusPlacemarkIconService) {}

  public getStatusPMIcon(pm: IPlacemark, layer: ILayer): string {
    let color: string = '';
    let shape = StatusShape.Circle;
    if (layer.visualizationMethod != STATUS_VISUALIZATION_METHOD.STATUS_TAG 
      && pm.showVisualization && pm.visualizationConf.visibilityType == 'valuesOnCollapseIcon') {
        return `${environment.windowOrigin}/${STATUS_LAYER_ICON_PRE}no_status_icon.png`;
    }
    if (pm.statusType === 'STATUS') {
      color = layer.statusColors[pm.selectedStatus];
      shape = layer.statusShapes[pm.selectedStatus];
    } else if (layer.logicType === 1) {
      if (layer.createdByApp === LAYER_CREATED_BY_APP.CHECKLIST && !(pm.issues.some(issue => (issue !== -1 && issue !== 0)))) {
        color = 'bebebe';
        shape = StatusShape.Circle;
      } else {
        let maxIssue: number = 0;
        for (let i = 0; i < pm.issues.length; i++) {
          maxIssue = pm.issues[i] > pm.issues[maxIssue] ? i : maxIssue;
        }
        color = layer.statusColors[maxIssue];
        shape = layer.statusShapes[maxIssue];
      }
    } else {
      if (layer.createdByApp === LAYER_CREATED_BY_APP.CHECKLIST && !(pm.issues.some(issue => (issue !== -1 && issue !== 0)))) {
        color = 'bebebe';
        shape = StatusShape.Circle;
      } else {
        for (let i = 0; i < pm.issues.length; i++) {
          if (pm.issues[i] > 0 && this.hasStatus(layer, STATUS_LAYER_MASK['STATUS' + (i + 1)])) {
            color = layer.statusColors[i];
            shape = layer.statusShapes[i];
            break;
          }
        }
      }
    }
    const iconUrl = this.statusPlacemarkIconService.getStatusPlacemarkIconUrl(color ?? '', shape ?? StatusShape.Circle);
    return iconUrl;
  }

  public hasStatus(layer: ILayer, statusMask: STATUS_LAYER_MASK): boolean {
    return (layer.layerStatus & statusMask) === statusMask;
  }
}
